import React, { Component } from 'react';
import { connect } from 'react-redux';

class DatosComprador extends Component {
    render() {
        const { isSeller, isSellerAdmin, isAdminMod } = this.props.userType;
        const { orden } = this.props.orden;
        const cliente = orden?.cliente || this.props.orden.cliente || {};

        const showContactInfo = isAdminMod ||
            ((isSeller || isSellerAdmin) && (orden?.seller?.mostrarInfoContacto || orden?.seller?.envioPropio));

        return (
            <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
                <div className="row">

                    <div className="form-group col-lg-6">
                        <label>{cliente?.tipoDocumento || "DNI"}</label>
                        <input
                            type="text"
                            className="form-control"
                            value={cliente.documento}
                            placeholder=""
                            name="documento"
                        />
                    </div>

                    <div className="form-group col-lg-6">
                        <label>Nombre comprador</label>
                        <input
                            type="text"
                            className="form-control"
                            value={cliente.nombre + ' ' + cliente.apellido}
                            placeholder=""
                            name="nombre"
                        />
                    </div>

                    <div className="form-group col-lg-3">
                        <label>Calle</label>
                        <input
                            type="text"
                            className="form-control"
                            value={cliente.calle}
                            placeholder=""
                            name="calle"
                        />
                    </div>

                    <div className="form-group col-lg-3">
                        <label>Número</label>
                        <input
                            type="text"
                            className="form-control"
                            value={cliente.numero}
                            placeholder=""
                            name="numero"
                        />
                    </div>

                    <div className="form-group col-lg-6">
                        <label>Piso</label>
                        <input
                            type="text"
                            className="form-control"
                            value={cliente.piso}
                            placeholder=""
                            name="piso"
                        />
                    </div>

                    <div className="form-group col-lg-6">
                        <label>Departamento</label>
                        <input
                            type="text"
                            className="form-control"
                            value={cliente.departamento}
                            placeholder=""
                            name="departamento"
                        />
                    </div>

                    <div className="form-group col-lg-6">
                        <label>Código postal</label>
                        <input
                            type="text"
                            className="form-control"
                            value={cliente.codigoPostal}
                            placeholder=""
                            name="codigoPostal"
                        />
                    </div>

                    <div className="form-group col-lg-6">
                        <label>Localidad</label>
                        <input
                            type="text"
                            className="form-control"
                            value={cliente.localidad}
                            placeholder=""
                            name="localidad"
                        />
                    </div>

                    <div className="form-group col-lg-6">
                        <label>Provincia</label>
                        <input
                            type="text"
                            className="form-control"
                            value={cliente.provincia}
                            placeholder=""
                            name="provincia"
                        />
                    </div>

                    {showContactInfo &&
                        <>
                            <div className="form-group col-lg-6">
                                <label>Email</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={cliente.email}
                                    placeholder=""
                                />
                            </div>

                            <div className="form-group col-lg-6">
                                <label>Teléfono</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={cliente.telefono}
                                    placeholder=""
                                />
                            </div>
                        </>
                    }

                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    userType: state.general.userType,
    orden: state.ordenes
});

export default connect(mapStateToProps)(DatosComprador);